<template>
  <div>
    <DarkModeSwitcher />
    <div class="container sm:px-10">
      <div class="block xl:grid grid-cols-2 gap-4">
        <!-- BEGIN: Login Info -->
        <div class="hidden xl:flex flex-col min-h-screen">
          <a href="" class="-intro-x flex items-center pt-5">
            <span class="text-white text-lg ml-3">
              AppWorks <span class="font-medium">CDN</span>
            </span>
          </a>
          <div class="my-auto">
            <img
              alt="Icewall Tailwind HTML Admin Template"
              class="-intro-x w-1/2 -mt-16"
              :src="require(`@/assets/images/illustration.svg`)"
            />
            <div
              class="-intro-x text-white font-medium text-4xl leading-tight mt-10"
            >
              A few more clicks to <br />
              sign in to your account.
            </div>
            <div
              class="-intro-x mt-5 text-lg text-white text-opacity-70 dark:text-gray-500"
            >
              Manage all your CDN products in one place
            </div>
          </div>
        </div>
        <!-- END: Login Info -->
        <!-- BEGIN: Login Form -->
        <div class="h-screen xl:h-auto flex py-5 xl:py-0 my-10 xl:my-0">
          <div
            class="my-auto mx-auto xl:ml-20 bg-white dark:bg-dark-1 xl:bg-transparent px-5 sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none w-full sm:w-3/4 lg:w-2/4 xl:w-auto"
          >
            <h2
              class="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left"
            >
              Zaloguj się
            </h2>
            <div class="intro-x mt-2 text-gray-500 xl:hidden text-center">
              A few more clicks to sign in to your account. Manage all your CDN products in one place
            </div>
            <div class="intro-x mt-8">
              <input
                type="text"
                class="intro-x login__input form-control py-3 px-4 border-gray-300 block"
                placeholder="Email"
                v-model="login"
              />
              <input
                type="password"
                class="intro-x login__input form-control py-3 px-4 border-gray-300 block mt-4"
                placeholder="Hasło"
                v-model="password"
              />
            </div>
<!--            <div-->
<!--              class="intro-x flex text-gray-700 dark:text-gray-600 text-xs sm:text-sm mt-4"-->
<!--            >-->
<!--              <div class="flex items-center mr-auto">-->
<!--                <input-->
<!--                  id="remember-me"-->
<!--                  type="checkbox"-->
<!--                  class="form-check-input border mr-2"-->
<!--                />-->
<!--                <label class="cursor-pointer select-none" for="remember-me"-->
<!--                  >Remember me</label-->
<!--                >-->
<!--              </div>-->
<!--              <a href="">Forgot Password?</a>-->
<!--            </div>-->
            <div class="intro-x mt-5 xl:mt-8 text-center xl:text-left">
              <button
                class="btn btn-primary py-3 px-4 w-full xl:w-32 xl:mr-3 align-top"
                @click="handleLogin"
              >
                Zaloguj się
              </button>
<!--              <button-->
<!--                class="btn btn-outline-secondary py-3 px-4 w-full xl:w-32 mt-3 xl:mt-0 align-top"-->
<!--              >-->
<!--                Sign up-->
<!--              </button>-->
            </div>
<!--            <div-->
<!--              class="intro-x mt-10 xl:mt-24 text-gray-700 dark:text-gray-600 text-center xl:text-left"-->
<!--            >-->
<!--              By signin up, you agree to our <br />-->
<!--              <a class="text-theme-30 dark:text-theme-10" href=""-->
<!--                >Terms and Conditions</a-->
<!--              >-->
<!--              &-->
<!--              <a class="text-theme-30 dark:text-theme-10" href=""-->
<!--                >Privacy Policy</a-->
<!--              >-->
<!--            </div>-->
          </div>
        </div>
        <!-- END: Login Form -->
      </div>
    </div>
    <div id="success-notification-content" class="toastify-content hidden flex">
      <CheckCircleIcon class="text-theme-20" />
      <div class="ml-4 mr-4">
        <div class="font-medium">Zalogowano!</div>
<!--        <div class="text-gray-600 mt-1">-->
<!--          The message will be sent in 5 minutes.-->
<!--        </div>-->
      </div>
    </div>
    <div id="validation-failed-notification-content" class="toastify-content hidden flex">
      <CheckCircleIcon class="text-theme-20" />
      <div class="ml-4 mr-4">
        <div class="font-medium">Uzupełnij wymagane pola</div>
<!--        <div class="text-gray-600 mt-1">-->
<!--          Sprawdź wprowadzony login i spróbuj ponownie.-->
<!--        </div>-->
      </div>
    </div>
    <div id="user-not-found-notification-content" class="toastify-content hidden flex">
      <CheckCircleIcon class="text-theme-20" />
      <div class="ml-4 mr-4">
        <div class="font-medium">Nie znaleziono takiego użytkownika</div>
        <div class="text-gray-600 mt-1">
          Sprawdź wprowadzony login i spróbuj ponownie.
        </div>
      </div>
    </div>
    <div id="password-mismatch-notification-content" class="toastify-content hidden flex">
      <CheckCircleIcon class="text-theme-20" />
      <div class="ml-4 mr-4">
        <div class="font-medium">Podane hasło jest nieprawidłowe</div>
        <div class="text-gray-600 mt-1">
          Popraw je i spróbuj ponownie.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue'
import Toastify from 'toastify-js'
import DarkModeSwitcher from '@/components/dark-mode-switcher/Main.vue'
import { uri, api } from '@/utils/axios'

export default defineComponent({
  components: {
    DarkModeSwitcher
  },
  setup() {
    const login = ref('')
    const password = ref('')
    const handleLogin = () => {
      window.axios.get(uri.csrfUrl).then(() => {
        window.axios.post(api('login'), {
          login: login.value,
          password: password.value
        }).then(({ data: { token } }) => {
          window.sessionStorage.setItem('web_token', token)
          Toastify({
            node: cash('#success-notification-content')
              .clone()
              .removeClass('hidden')[0],
            duration: 5000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
        }).catch(({ response }) => {
          if (response && response.data && response.data.message) {
            if (response.data.message === 'validation_failed') {
              Toastify({
                node: cash('#validation-failed-notification-content')
                  .clone()
                  .removeClass('hidden')[0],
                duration: 6000,
                newWindow: true,
                close: true,
                gravity: 'top',
                position: 'right',
                stopOnFocus: true
              }).showToast()
            } else if (response.data.message === 'user_not_found') {
              Toastify({
                node: cash('#user-not-found-notification-content')
                  .clone()
                  .removeClass('hidden')[0],
                duration: 6000,
                newWindow: true,
                close: true,
                gravity: 'top',
                position: 'right',
                stopOnFocus: true
              }).showToast()
            } else if (response.data.message === 'password_mismatch') {
              Toastify({
                node: cash('#password-mismatch-notification-content')
                  .clone()
                  .removeClass('hidden')[0],
                duration: 6000,
                newWindow: true,
                close: true,
                gravity: 'top',
                position: 'right',
                stopOnFocus: true
              }).showToast()
            }
          }
        })
      })
    }

    onMounted(() => {
      cash('body')
        .removeClass('main')
        .removeClass('error-page')
        .addClass('login')
    })
    return { login, password, handleLogin }
  }
})
</script>
